import React from "react";

function AttachMenu({ onPick }) {
  return (
    <div className="attach-menu-card shadow-lg border rounded p-2">
      <button className="attach-item-btn" onClick={() => onPick("image")}> Gallery</button>

      <button className="attach-item-btn" onClick={() => onPick("camera")}>
         Camera
      </button>

      <button className="attach-item-btn" onClick={() => onPick("video")}> Video</button>
      <button className="attach-item-btn" onClick={() => onPick("audio")}> Audio</button>
      <button className="attach-item-btn" onClick={() => onPick("file")}> Document</button>
    </div>
  );
}

export default AttachMenu;